import { parseFieldId } from '~/features/fields/isLegacyPilotFieldId';
import { PromptModel } from '~/features/x-ray/types/deprecated';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import { PromptModel as PromptModelResponse } from '../../types/sylvanus/model';

interface Request {
  modelId: Uuid;
}

export const getPromptModel = async ({
  modelId,
}: Request): Promise<PromptModel> => {
  const response: PromptModelResponse = await sylvanus.get(`/model/${modelId}`);

  return {
    currentOptimizeInfo: response.current_optimize
      ? {
          id: response.current_optimize.optimize_run_id,
          state: response.current_optimize.state,
          testCaseCount: response.current_optimize.total_test_cases ?? 0,
          version: response.current_optimize.version_number,
        }
      : null,
    id: response.id,
    versions: response.version_numbers ?? [],
    fieldId: parseFieldId(response.target_entity.id),
    publishStatus: response.current_publish?.status,
    currentPublished: response.current_publish ?? null,
  };
};
